/*
 * @Author: zhangyugegeliuchen@didichuxing.com 
 * @Date: 2019-01-08 18:16:03
 * @Last Modified by: zhaozhaozhao
 * @Last Modified time: 2023-07-19 20:44:49
 * @Description:  btd落地页
 */
<template>
  <Creator :name="componentName" />
</template>
<script>
import LandingPageV2 from './landingPageV2'
import Creator from './modules/pageCreater'

export default {
  name: 'btdLandingPage',
  components: {
    Creator
  },
  computed: {
    componentName () {
      return LandingPageV2
    }
  }
}
</script>
<style>
</style>
